import type { ChartData, ChartOptions } from 'chart.js';
import { lazy, Suspense } from 'react';

const lineChartOptions:ChartOptions<'line'> = {
  responsive: true,
  scales: {
    y: {
      min: 0,
    },
  },
  plugins: {
    legend: {
      position: 'bottom' as const,
      labels: {
        usePointStyle: true,
        generateLabels: (chart) => {
          return [
            {
              text: ' Normal Reading  ',
              fillStyle: 'rgba(0, 166, 81, 1)',
              strokeStyle: 'rgba(0, 166, 81, 1)',
              lineCap: 'butt',
              lineDash: [],
              lineDashOffset: 0,
              lineJoin: 'miter',
              lineWidth: 2,
              pointStyle: 'circle',
            },
            {
              text: ' Abnormal Reading  ',
              fillStyle: 'white',
              strokeStyle: 'rgba(255, 205, 86, 1)',
              lineCap: 'butt',
              lineDash: [],
              lineDashOffset: 0,
              lineJoin: 'miter',
              lineWidth: 2,
              pointStyle: 'circle',
            },
            {
              text: ' Critical Reading',
              fillStyle: 'white',
              strokeStyle: 'rgba(255, 99, 132, 1)',
              lineCap: 'butt',
              lineDash: [],
              lineDashOffset: 0,
              lineJoin: 'miter',
              lineWidth: 2,
              pointStyle: 'circle',
            },
          ];
        },
      },
    },
  },
};

interface LineChartProps {
  readonly chartData: ChartData<'line', number[]>;
}

const AsyncLine = lazy(async () => {
  const { CategoryScale, Chart, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } = await import(
    'chart.js'
  );
  Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
  const { Line } = await import('react-chartjs-2');
  return { default: Line };
});

export function LineChart({ chartData }: LineChartProps): JSX.Element {
  return (
    <div className="my-5">
      <Suspense fallback={<div>Loading...</div>}>
        <AsyncLine options={lineChartOptions} data={chartData} />
      </Suspense>
    </div>
  );
}
